module.exports = __webpack_public_path__ + "img/header-engagementRingsModern@2x.e52afc4.webp";